import styled from "styled-components";
import { colors, fontSizes, lineHeights } from "../theme";
import { bgColorProp, brProps, colorProp, fwProp } from "./helpers";

export const Text = styled.p`
  font-size: ${(pr) => fontSizes[pr.variant || "p"]};
  font-weight: ${(pr) => {
    return { h1: 900, h2: 700, h3: 700, h4: 700 }[pr.variant];
  }};
  line-height: ${(pr) => lineHeights[pr.variant || "p"]};
  ${colorProp};
  ${fwProp};
  line-height: ${(pr) => pr.lineHeight};
  text-align: ${(pr) => pr.align};
`;

export const Span = styled.span`
  ${colorProp};
  font-weight: ${({ b }) => b && 700};
  ${({ color }) => {
    if (["Pyro", "orange", "Red"].includes(color)) {
      return `
        position: relative;
        bottom: ${color === "Pyro" ? "-2px" : "-1px"};
      `;
    }
  }}
`;

export const spanMaker = (color) => (props) => (
  <Span color={color} {...props} />
);

export const GreenOn = ({ on, children }) => (
  <Span color="green" className={on ? "" : "unavailable"}>
    {children}
  </Span>
);

export const Green = spanMaker("green");
export const Red = spanMaker("lightRed");
export const Gold = spanMaker("Gold");
export const Orange = spanMaker("orange");
export const Pyro = spanMaker("Pyro");
export const Hydro = spanMaker("Hydro");
export const Cryo = spanMaker("Cryo");
export const Electro = spanMaker("Electro");
export const Geo = spanMaker("Geo");
export const Anemo = spanMaker("Anemo");
export const Dendro = spanMaker("Dendro");

export const anemoIA = (
  <>
    <Hydro>Hydro</Hydro>/<Pyro>Pyro</Pyro>/<Cryo>Cryo</Cryo>/
    <Electro>Electro</Electro>
  </>
);

export const pyroDmg = <Pyro>Pyro DMG</Pyro>;
export const hydroDmg = <Hydro>Hydro DMG</Hydro>;
export const cryoDmg = <Cryo>Cryo DMG</Cryo>;
export const electroDmg = <Electro>Electro DMG</Electro>;
export const geoDmg = <Geo>Geo DMG</Geo>;
export const anemoDmg = <Anemo>Anemo DMG</Anemo>;
export const dendroDmg = <Dendro>Dendro DMG</Dendro>;

export const Tooltip = styled.div`
  position: absolute;
  top: ${(pr) => pr.top};
  bottom: ${(pr) => pr.bottom};
  right: ${(pr) => pr.right};
  left: ${(pr) => pr.left};
  z-index: 10;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: rgba(0, 0, 0, 0.9);
  ${colorProp};
`;

export const List = styled.ul`
  list-style-position: ${(pr) => pr.position};
  list-style-type: ${(pr) => pr.type};
  & > li {
    line-height: 1.5;
  }
`;

export const Table = styled.table`
  min-width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  line-height: 1.43;
  th,
  td {
    padding: 0.25rem 0.5rem;
    border-left: 1px solid ${colors.cardBg1};
    border-right: 1px solid ${colors.cardBg1};
    cursor: default;
  }
  td:first-child {
    font-weight: 700;
  }
  td:not(:first-child) {
    text-align: right;
  }
  tr:nth-child(2n) {
    background-color: ${colors.cardBg2};
  }
  tr:nth-child(2n + 1) {
    background-color: ${colors.cardBg1};
  }
  tr:first-child {
    background-color: #01121b;
  }
  tr:not(:first-child):hover {
    background-color: #8a1200;
    .warning {
      color: ${colors.green};
    }
  }
  .lightGold-text {
    color: ${colors.lightGold};
  }
  .warning {
    color: ${colors.lightRed};
  }
`;

export const Img = styled.img`
  width: ${(pr) => pr.width};
  height: ${(pr) => pr.height}};
  ${brProps};
  ${bgColorProp};
  transition: opacity ease-out 150ms;
`;

export const CollapseHeading = styled.p`
  padding: 0.25rem 1rem 0;
  background: ${colors.cardBg3};
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.6;
  &.mb-2p5 {
    margin-bottom: 0.75rem;
  }
  &.active {
    background: #f5dc6e;
    color: black;
  }
`;

export const CollapseContent = styled.div`
  padding: 0 1rem 0 0.5rem;
  & .mb-m1:first-child {
    margin-top: -0.5rem;
  }
`;

export const Link = styled.a`
  &:link,
  &:visited {
    color: ${colors.green};
    text-decoration: none;
  }
  &:hover {
    color: ${colors.lightRed};
  }
`;
